module.exports = __webpack_public_path__ + "img/Pfade_Tabea_9.f28ec922.png";